module.exports = __webpack_public_path__ + "static/favicon-0d33b4c9708809645a9526c1a8232384.ico";